import { BlogList } from './BlogList'
import '../css/bloglisting.css'
import axios from 'axios'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'

const BlogListing = ({ limit }) => {

  const [blogs, setBlogs] = useState([]);
  const url = process.env.REACT_APP_BASE_URL
  // const url =  "http://localhost:4000"

  const getAllBlogs = async () => {
    try {
      const response = await axios.get(`${url}/api/blog/list`);
      const sortedBlogs = response.data.data.sort((a, b) => new Date(b.created) - new Date(a.created));
      setBlogs(sortedBlogs);
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.error('Error fetching data:', error);
      }
      toast.error('Failed to fetch blogs. Please try again later.');
    }
  };
  
  useEffect(()=>{
    getAllBlogs();
  },[]);

  const displayedBlogs = limit ? blogs.slice(0, limit) : blogs;

  return (
    <div className='blog-display'>
        <h2 className='blog-display-title'>प्रसंग विशेष</h2>
    <div className='blog-display-list'>
       {
           displayedBlogs.map((blog)=>{
            return <BlogList key={blog._id} blog={blog}/>
           }) 
        }
       </div>
    </div>
  )
}

export default BlogListing